 

import { Env } from "@version2/domain-package";

// firebase env
const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
const FIREBASE_DATABASE_URL = process.env.REACT_APP_FIREBASE_DATABASE_URL;
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
const GOOGLE_TAG_MANAGER_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || "";

// local env
const IS_DEBUG = process.env.REACT_APP_IS_DEBUG === "true";
const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === "true";
const ENV = (process.env.REACT_APP_ENV || Env.PROD) as Env;
const FIRESTORE_EMULATOR_PORT =
  process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || "8080";
const AUTH_EMULATOR_PORT = process.env.REACT_APP_AUTH_EMULATOR_PORT || "9099";
const FUNCTIONS_EMULATOR_PORT =
  process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || "5001";

// sentry env
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";

// paddle env
const PADDLE_CLIENT_TOKEN = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;
const PROFITWELL_API_KEY = process.env.REACT_APP_PROFITWELL_API_KEY;

// oauth env
const AIRTABLE_OAUTH_CLIENT_ID = process.env.REACT_APP_AIRTABLE_OAUTH_CLIENT_ID;
const GOOGLE_CLOUD_OAUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLOUD_OAUTH_CLIENT_ID;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || window.location.origin;

// app urls
const LANDING_URL = process.env.REACT_APP_LANDING_URL || "https://version2.io";
const DASH_URL = process.env.REACT_APP_DASH_URL || "https://dash.version2.io";

// clickconnector env
const CLICKCONNECTOR_WIDGET_ID = process.env.REACT_APP_CLICKCONNECTOR_WIDGET_ID;

const env = {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_DATABASE_URL,
  RECAPTCHA_SITE_KEY,
  GOOGLE_TAG_MANAGER_ID,

  IS_DEBUG,
  IS_LOCAL,
  ENV,
  FIRESTORE_EMULATOR_PORT,
  AUTH_EMULATOR_PORT,
  FUNCTIONS_EMULATOR_PORT,
  SENTRY_DSN,
  PADDLE_CLIENT_TOKEN,
  PROFITWELL_API_KEY,

  AIRTABLE_OAUTH_CLIENT_ID,
  GOOGLE_CLOUD_OAUTH_CLIENT_ID,
  API_BASE_URL,

  LANDING_URL,
  DASH_URL,

  CLICKCONNECTOR_WIDGET_ID,
};

export default env;
